import { useTranslations } from "next-intl";
import { IDCart } from "../_icons/idCard";

interface AgeRestrictedProps {
  textClassName?: string;
  text?: string;
}

export const AgeRestricted = ({ textClassName, text }: AgeRestrictedProps) => {
  const t = useTranslations();
  return (
    <div className="flex gap-3 py-2">
      <IDCart />
      <p className={`font-weight-[400] text-[#000000] ${textClassName}`}>
        {text || t("AgeRestricted.text")}
      </p>
    </div>
  );
};
